import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/style/home.scss';
import CityDom from './selectCity'
import CountryDom from './selectCountry'
import Banner from './banner'

const homeData = {
	product: {
		title: {
			chinese: '我们的产品',
			english: 'OUR PRODUCTS'
		},
		subtitle: {
			chinese: '致力发展智能物流，美国专线，英国专线，邮政小包等服务，我们要求时效严格，全程跟踪客户的包裹信息，根据客户不同的需求，准确掌握客户信息，服务优先，并且价格合理。',
			english: 'PMS focus on the developments of intelligent logistics The main business includes US Logistics direct line, UK Logistics direct line and China Postal packet services and other services.We are serious to our delivery time and trace the packages’ information for our clients. According to the different needs of customers, we can grasp information of customers accurately, providing service priority, and using the price appropriately.'
		},
		data: [
			{
				name: {
					chinese: '美国专线',
					english: 'PMS-US Logistics Service'
				},
				image: '/home/am-banner.png',
				url: '/product/1',
				message: {
					chinese: ['派敏斯主营业务，优质美国资源整合', '时效稳定，全程跟踪'],
					english: ['It is the main business of PMS which has full-tracking packages service.', 'And it integrate the resource of US postal service.']
				}

			},
			{
				name: {
					chinese: '英国专线',
					english: 'PMS-UK Logistics Service'
				},
				image: '/home/en-banner.png',
				url: '/product/2',
				message: {
					chinese: ['空运+派送，海外仓换单', '服务多样、安全快捷'],
					english: ['This service includes air-express and delivery, postal label exchange. ', 'It is numerous ,safety and rapidly']
				}
			},
			{
				name: {
					chinese: '德国及欧盟专线',
					english: 'DE & EU Logistics Service'
				},
				image: '/home/e-banner.png',
				url: '/product/3',
				message: {
					chinese: ['空运+派送', '优质线路、全程跟踪'],
					english: ['Air&Delivery', 'In time delivery、Fully-Tracked Service']
				}
			},
			{
				name: {
					chinese: '邮政小包服务',
					english: 'PMS Postal Service'
				},
				image: '/home/litter-banner.png',
				url: '/product/4',
				message: {
					chinese: ['优质的小包资源整合', '自动筛选最优的邮政小包服务'],
					english: ['Integrating the excellent small-parcels resources.', 'It can select the most suitable service for small-parcels']
				}
			},
			{
				name: {
					chinese: 'PMS空海运大货',
					english: 'PMS Air and Sea Cargo'
				},
				image: '/home/home-airCargo.png',
				url: '/product/5',
				message: {
						chinese: ['为FBA专线量身打造，无论是快递、海派、空派、卡航、铁路，统统满足'],
						english: ['Tailor-made for FBA special line, whether you are doing express delivery, sea delivery, air delivery, Qatar Airways, or railway, it is all satisfied']
				}
			}
		]
	},
	// news: {
	// 	title: {
	// 		chinese: '新闻资讯',
	// 		english: 'NEWS'
	// 	},
	// 	text: {
	// 		chinese: '新闻资讯包含海量咨询，快速捕捉出日益爆发的信息洪流中最核心的资讯，让您快速了解行业最新进展的新闻事件、热点话题、人物动态、产品咨询等，满足你对资讯的一切需求！',
	// 		english: 'In this part, you can search the core information of the news, which can meet your needs whatever the latest developments in the news events, heated topics, dynamic of characters, product consulting, etc.'
	// 	}
	// },
	details: {
		chinese: '了解详情',
		english: 'Details'
	},
	productBtn: {
		chinese: '了解更多',
		english: 'MORE INFO'
	},
	image: {
		chinese: '派你所想，永不言退，把握现在，成就非凡未来',
		english: 'Dispatch what you think and never ever delay.'
	},
	message: {
		title: {
			chinese: '联系我们',
			english: 'CONTACT us'
		},
		text: {
			text1: {
				chinese: '派敏斯速递对您提交的个人信息资料采取保密措施，敬请放心。',
				english: 'Email us with as much detail as you can so we can give you the best help possible.'
			},
			text2: {
				chinese: '为确保我们能第一时间联系您，请务必准确填写联系方，感谢您的配合。',
				english: ''
			}
		},
		placeholder: {
			chinese: {
				username: '您的称呼：*',
				infomation: '您的联系方式：*',
				message: '留言内容：*',
				submit: '提交留言'
			},
			english: {
				username: 'Your name',
				infomation: 'Your contact information',
				message: 'Message',
				submit: 'submit'
			}
		}
	}
}
export default class Home extends React.Component {
	state = {
		timer: null,
		formData: {
			price: "",
		},
	}
	constructor(props) {
		super(props);
		this.state = {
			timer: null,
			cityStatus: false,
			countryStatus: false,
			countryName: "",
			countryValue: "",
			weights: null,
			cityName: "",
			cityValue: "",
			status: '',
			length_: null,
			width: null,
			height: null,
			postcode: ""
		}
	}
	setProductList() {
		let { language } = this.props;
		return (
			<div className="pms--home-main-list">
				<div className="center clear">
					{
						homeData.product.data.map((data, key) =>
							<div className="pms--home-main-item" key={key.toString()}>
								<Link to={data.url}>
									<div className="pms--home-main-item-container">
										<figure className="pms--home-main-item--container">
											<div className="pms--home-main-item-img">
												<img src={data.image} alt="" />
											</div>
											<figcaption className="pms--home-main-item-title">
												<dl>
													<dt>{data.name[language]}</dt>
													<dd>
														{data.message[language].map((value, key) =>
															<p key={key.toString()}>{value}</p>
														)}
													</dd>
													<dd className="pms--home-product-bottom">{homeData.productBtn[language]}</dd>
												</dl>
											</figcaption>
										</figure>
									</div>
								</Link>
							</div>)
					}
				</div>
			</div>
		)
	}
	formClick() {
		this.props.history.push({ pathname: '/about/price', query: this.state })
	}
	change(e, num) {
		console.log(e.target.value);    //获取修改后的值
		if (num == 0) {
			this.setState({
				length_: e.target.value
			})
		}
		if (num == 1) {
			this.setState({
				width: e.target.value
			})
		}
		if (num == 2) {
			this.setState({
				height: e.target.value
			})
		}
		if (num == 3) {
			this.setState({
				postcode: e.target.value
			})
		}
		if (num == 4) {
			this.setState({
				weights: e.target.value
			})
		}
	}
	citysChange(e) {

	}
	getChildrenMsg = (result, msg) => {
		// 很奇怪这里的result就是子组件那bind的第一个参数this，msg是第二个参数
		this.setState({
			cityName: msg.name,
			cityValue: msg.value,
			cityStatus: false
		})
	}
	getCountryMsg = (result, msg) => {
		// 很奇怪这里的result就是子组件那bind的第一个参数this，msg是第二个参数
		this.setState({
			countryName: msg.name,
			countryValue: msg.value,
			countryStatus: false
		})
	}
	componentWillUnmount() {

	}
	render() {

		let { language } = this.props;
		return (
			<div className="pms-container-home pms-home">
				<div className="pms-banner-container">
					<div className="pms-price-search">
						<p>价格查询</p>
						<div className="pms-price-search-item">
							<span style={{ width: 56 + "px", marginRight: 20 + "px" }}>发件城市
							</span>
							<div className="pms-price-search-right" onClick={
								() => {
									this.setState({
										cityStatus: !this.state.cityStatus,
										status: 'city',
										countryStatus: false
									})
								}
							}>
								<span>{this.state.cityName}</span>
								<span className={this.state.cityStatus ? 'triangle1' : 'triangle'}></span>
							</div>
							<CityDom className="pms-select" parent={this}></CityDom>
						</div>
						<div className="pms-price-search-item">
							<span style={{ width: 56 + "px", marginRight: 20 + "px" }}>目的国家</span>
							<div className="pms-price-search-right" onClick={() => {
								this.setState({
									countryStatus: !this.state.countryStatus,
									status: 'country',
									cityStatus: false
								})
							}}>
								<span>{this.state.countryName}</span>
								<span className={this.state.countryStatus ? 'triangle1' : 'triangle'}></span>
							</div>
							<CountryDom className="pms-select" parent={this}></CountryDom>
						</div>
						<div className={(this.state.countryValue == 'US' || this.state.countryValue == 'AU') ? "pms-price-search-item" : "pms-price-search-item-off"}>
							<span style={{ width: 56 + "px", marginRight: 20 + "px" }}>邮编</span>
							<input value={this.state.postcode} onChange={(event) => { this.change(event, 3) }}></input>
						</div>
						<div className="pms-price-search-item weight"><span style={{ width: 56 + "px", marginRight: 20 + "px" }}>重量</span><input type="input" onChange={(event) => { this.change(event, 4) }} ref="city" value={this.state.weights} />KG</div>
						<div className="pms-price-search-item"><span style={{ width: 56 + "px", marginRight: 20 + "px" }}>包裹体积</span><input type="input" placeholder="" onChange={(event) => { this.change(event, 0) }} ref="city" value={this.state.length_} /><span style={{ fontSize: 10 + 'px' }}>CM&nbsp;&nbsp;x</span>
							<input type="input" placeholder="" onChange={(event) => { this.change(event, 1) }} ref="city" value={this.state.width} /><span style={{ fontSize: 10 + 'px', marginRight: 4 + 'px' }}>CM&nbsp;&nbsp;x</span>
							<input type="input" placeholder="" onChange={(event) => { this.change(event, 2) }} ref="city" value={this.state.height} /><span style={{ fontSize: 10 + 'px', marginRight: 4 + 'px' }}>CM</span></div>
						<button className="pms-price-search-submit" onClick={
							() => this.formClick()
						}>

							查询</button>
					</div>
					<Banner></Banner>
				</div>
				<div className="pms-main-content">
					<div className="pms-main-header">
						<h2 className="title-center">{homeData.product.title[language]}</h2>
					</div>
					{this.setProductList()}
					<div className="pms--mian-baner">
						<p>{homeData.image[language]}</p>
					</div>
					{/* <div className="center">
						<div className="pms-main-header" style={{ background: '#fff' }}>
							<h2>{homeData.news.title[language]}</h2>
						</div>
						<div className="pms--home-news-list">
							<div className="pms--home-news-container clear">
								<div className="col-xs-3">
									<Link to="/news/1">
										<div className="home--news-list-img">
											<img src={require('../assets/image/news-1.png')} alt="" />
										</div>
										<div className="home-news-list-info">
											<p>Amazon百万大卖家分享</p>
											<p className="home-news-list-miantitle ellipsis">从零开始一路奋战至今的心得经验</p>
											<p>同一个时期起步做跨境电商的卖家，有人分文未赚，有人越做越大致富发家。同样的平台和时机，却往往有不同的结果...</p>
										</div>
									</Link>
								</div>
								<div className="col-xs-3">
									<Link to="/news/2">
										<div className="home--news-list-img">
											<img src={require('../assets/image/news-2.png')} alt="" />
										</div>
										<div className="home-news-list-info">
											<p>资讯</p>
											<p className="home-news-list-miantitle ellipsis">跨境电商加剧物流需“下猛药”，如何多样化服务好中国卖家？</p>
											<p>跨境电商迅猛的发展态势要求现代物流为之提供一个涵盖流通、配送的实体运...</p>
										</div>
									</Link>
								</div>
								<div className="col-xs-3">
									<Link to="/news/3">
										<div className="home--news-list-img">
											<img src={require('../assets/image/news-3.png')} alt="" />
										</div>
										<div className="home-news-list-info">
											<p>跨境运营干货</p>
											<p className="home-news-list-miantitle ellipsis">Wish卖家如何做好海外仓？ </p>
											<p>Wish中国区总裁丁浩川曾表示，海外仓将是Wish未来重点打造的一个方向。众所周知，不少跨境电商平台和出口企...</p>
										</div>
									</Link>
								</div>
								<div className="col-xs-3">
									<Link to="/news/4">
										<div className="home--news-list-img">
											<img src={require('../assets/image/news-4.png')} alt="" />
										</div>
										<div className="home-news-list-info">
											<p>独立网站资讯</p>
											<p className="home-news-list-miantitle ellipsis">最佳弹窗设计：让转化率再飞一会儿 </p>
											<p>网站弹窗改变了电商邀请访客参与互动、以及转化访客的方式，它非常有效...</p>
										</div>
									</Link>
								</div>
							</div>
						</div>
					</div> */}
				</div>
				<div className="pms-contact-form pms-home-contact-form">
					<div className="pms-home-contact-form-center">
						<p className="contact-form-title">{homeData.message.title[language]}</p>
						<p className="contact-form-tips">{homeData.message.text.text1[language]}</p>
						<p className="contact-form-tips">{homeData.message.text.text2[language]}</p>
						<form action="">
							<div className="clear">
								<div className="col-xs-5"><input type="text" placeholder={homeData.message.placeholder[language].username} /></div>
								<div className="col-xs-2"></div>
								<div className="col-xs-5"><input type="text" placeholder={homeData.message.placeholder[language].infomation} /></div>
							</div>
							<div className="clear">
								<textarea name="" id="" cols="30" rows="5" placeholder={homeData.message.placeholder[language].message}></textarea>
							</div>
							<div className="clear form-submit">
								<div className="col-xs-9"></div>
								<div className="col-xs-3">
									<button type="button">{homeData.message.placeholder[language].submit}</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div >
		)
	}
}



// WEBPACK FOOTER //
// ./public/views/home.js